import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import TextBox from "../controls/form/TextBox";
import { useCallback } from "react";
import Deployment from "../../services/deployment";

const ChangeCnameModal = ({ deployment, show, onCancel,onUpdate }) => {
    const [translate] = useTranslation();

    const update = useCallback(async ({ cname }) => {
        const response = await Deployment.updateDeployment(deployment._id, {
            cname
        });

        if (!response.error) {
            onUpdate();
        }
    }, [onUpdate, deployment]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik
                initialValues={{
                    cname: deployment?.cname || "",
                }}
                validationSchema={Yup.object({
                    cname: Yup.string().min(2).matches(/^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9-]*[a-zA-Z0-9]).)*([A-Za-z]|[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9])$/, translate("OTM_INVALID_CNAME"))
                })}
                onSubmit={update}
                enableReinitialize
            >
                <Form>
                    <BootstrapModal.Header className="h5 text-secondary">
                        {translate("OTM_CHANGE_CNAME")}
                    </BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <TextBox
                            label={translate("OTM_CNAME")}
                            type="text"
                            name="cname"
                            css="mt-3"
                        />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" className="btn-sm">
                            {translate("OTM_UPDATE")}
                        </Button>
                        <Button
                            onClick={onCancel}
                            variant="secondary"
                            className="btn-sm"
                        >
                            {translate("OTM_CANCEL")}
                        </Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default ChangeCnameModal;